module.exports = __webpack_public_path__ + "cc76c8fbf9b67d3ebaa3b3d9189132de.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/calibre/calibre.woff
// module id = 1522
// module chunks = 0